














import Vue from 'vue';

export default Vue.extend({
  name: 'twitch-icon',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
